// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"e3b86a93","168":"64aba077","544":"f1b4b890","787":"8aab7313","879":"a4ef23c8"}[chunkId] + ".chunk.js";
};